import React, { useState } from 'react';

import Search from '../../Components/Search'
import ModalWarn from '../../Components/Modal/Warn/index'

export default function SearchLockUnlockUser(props) {
    const [ loadingUser, setLoadingUser ] = useState(false);   

    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");
    const [ cpfSearchErro, setCpfSearchErro] = useState(false);
    const [ cpfSearchErroMessage, setCpfSearchErroMessage ] = useState("");
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    const removeInputMask = (cpf) => {
        if (cpf === "") {
            return ""
        } else {
            return cpf?.replace(/[^\d]+/g, "");
        }
    };

    const onSubmitCPF = async (data) => {

        data = removeInputMask(data);
        setCpfSearchErro(false);
        //console.log(data);  // CPF DO USUÁRIO PESQUISADO

        setLoadingUser(true);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                codigo_orgao: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_orgao : "",
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_usuario se refere ao gestor que está cadastrando (que está atendendo)
                cpf_usuario: data
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/consultaUsuario`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data) {

                    const user = {
                        id_usuario_orgao: data.id_usuario_orgao,
                        cpf: data.cpf_usuario,
                        name: data.nome_usuario,
                        nome_rede_atendimento: data.nome_rede_atendimento,
                        nome_unidade: data.nome_unidade,
                        data_inclusao: data.data_inclusao,
                        data_expiracao: data.data_expiracao,
                        cpf_usuario_cadastrador: data.cpf_usuario_cadastrador,
                        nome_usuario_cadastrador: data.nome_usuario_cadastrador,
                        data_bloqueio: data.data_bloqueio,
                        motivo_bloqueio: data.motivo_bloqueio,
                        data_desbloqueio: data.data_desbloqueio,
                        motivo_desbloqueio: data.motivo_desbloqueio,
                        unidades_vinculadas: data.unidadesVinculadas,
                    }
                    setLoadingUser(false);

                    props.history.push("/bloquearDesbloquearUsuario", user);

                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setCpfSearchErro(true);
                        setCpfSearchErroMessage(data.message);
                    } else {
                        // inserir mensagem genérica
                        setCpfSearchErro(true);
                        setCpfSearchErroMessage('Houve algum problema no servidor.');
                        console.log('Response error in /gestao/consultaUsuario BackendBalcao');
                    }

                    setLoadingUser(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingUser(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingUser(false);
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return ( 
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <Search
                pageTitle='Bloquear ou Desbloquear Usuário'
                buttonBackRoute='/pesquisarcidadao'
                messageError={messageError}
                onSubmitCPF={onSubmitCPF}
                modalError={modalError}
                setModalError={setModalError}
                buttonNextLoading={loadingUser}
                cpfSearchErro={cpfSearchErro}
                setCpfSearchErro={setCpfSearchErro}
                cpfSearchErroMessage={cpfSearchErroMessage}
                history={props.history}
            />
        </>
    );
}